import GenericError from './generic-error'

export default class ValidationError extends GenericError {
  constructor (code = 400, response = {}, validationErrorResult = {}, ...params) {
    super(code, response, ...params)
    this.validationErrorResult = validationErrorResult
    if (validationErrorResult.validationErrors) {
      validationErrorResult.validationErrors.forEach(validationError => {
        this.message = this.message + validationError.message + '\n'
      })
    }
  }
}



// WEBPACK FOOTER //
// ./src/services/error/validation-error.js